<app-inline-edit-input
  [class]="{'text-danger' : !details.beneficialOwner && !details.isBeneficialOwner }"
  [controlLike]="controlLike"
  [value]="details.beneficialOwner || nonBeneficialOwnerLabel"
  [onSave]="updateBeneficialOwner(relationshipIds)"
>
  <!-- todo: replace with trust profile when ready -->
  @if (showOpenIcon) {
    <app-span-with-open-icon
      [route]="details.beneficialOwnerEntityId ? ['/companies', details.beneficialOwnerEntityId!] : []">
      @if (details.beneficialOwner) {
        {{ details.beneficialOwner }}
      } @else {
        <div class="d-inline-block rounded px-2 py-1 color-gray-700 bg-gray-200">{{ nonBeneficialOwnerLabel }}</div>
      }
    </app-span-with-open-icon>
  } @else {
    @if (details.beneficialOwner) {
      {{ details.beneficialOwner }}
    } @else {
      <div class="d-inline-block rounded px-2 color-gray-700 bg-gray-200">{{ nonBeneficialOwnerLabel }}</div>
    }
  }
</app-inline-edit-input>
